<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div class="padding-ten-tb">
      <b-row style="max-width: 100%">
        <b-col xs="12" sm="12" md="12" lg="4">
          <h5 class="color-gray">Proveedores</h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <h5 class="color-orange">Datos del proveedor</h5>
      <b-container fluid>
        <b-row class="padding-four-top">
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Representante</label>
            <b-form-input
              placeholder="Escriba aquí"
              type="text"
              v-model="formProvider.name"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Razón social</label>
            <b-form-input
              type="text"
              v-model="formProvider.socialReason"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Dirección</label>
            <b-form-input
              type="text"
              v-model="formProvider.direction"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Estado</label>
            <b-form-group>
              <b-form-select
                v-model="formProvider.state"
                size="md"
                :options="optionStates"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Usuario</label>
            <b-form-input
              type="text"
              v-model="formProvider.user"
              autocomplete="new-password"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Contraseña</label>
            <b-form-input
              type="password"
              v-model="formProvider.password"
              autocomplete="new-password"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">RUC</label>
            <b-form-input type="text" v-model="formProvider.ruc"></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Hora de corte</label>
            <b-form-timepicker
              placeholder="Seleccione la hora"
              v-model="formProvider.cutHour"
            ></b-form-timepicker>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Hora de corte Express</label>
            <b-form-timepicker
              show-seconds
              placeholder="Seleccione la hora"
              v-model="formProvider.cutHourEx"
            ></b-form-timepicker>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Tipo</label>
            <b-form-group>
              <b-form-select
                v-model="formProvider.type"
                size="md"
                :options="optionTypeProvider"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <b-form-checkbox
              id="checkbox-1"
              v-model="formProvider.beetrack"
              name="checkbox-1"
              >ONE TRACK
            </b-form-checkbox>
          </b-col>
          <b-col cols="auto">
            <b-form-checkbox
              id="checkbox-2"
              v-model="formProvider.automaticSO"
              name="checkbox-2"
              >OS automática
            </b-form-checkbox>
          </b-col>
          <b-col cols="auto">
            <b-form-checkbox
              id="checkbox-3"
              v-model="formProvider.express"
              name="checkbox-3"
              >Express
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <label class="text-grey">Empresa</label>
            <b-form-group class="display-inline-flex">
              <b-form-select
                v-model="selectedCompany"
                :options="companies"
                required
              >
               <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
              <b-button
                @click="addCompany"
                class="color-orange font-bolder"
              >
                +</b-button
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="formProvider.enterpriseAssignations.length">
          <b-col cols="12">
            <div class="border-grey">
              <ul class="padding-none">
                <li
                  class="bg-orange"
                  v-for="(company, index) in formProvider.enterpriseAssignations"
                  :key="index"
                >
                  {{ company.companyName }}
                  <span
                    class="bg-white color-black"
                    @click="deleteCompany(index, company.companyCode)">
                    x
                    </span>
                 
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <label class="text-grey">Sucursal</label>
            <b-form-group class="display-inline-flex">
              <b-form-select
                v-model="valueAdded.sucursal"
                :options="optionStores"
                required
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
              <b-button @click="addSucursal" class="color-orange font-bolder">
                +</b-button
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-show="formProvider.branchAssignations.length">
          <b-col cols="12">
            <div class="border-grey">
              <ul class="padding-none">
                <li
                  class="bg-orange"
                  v-for="(sucursal, index) in formProvider.branchAssignations"
                  :key="index"
                >
                  {{ sucursal.storeCode + "-" + sucursal.storeName }}
                  <span
                    class="bg-white color-black"
                    @click="deleteSucursal(index, sucursal.storeCode)"
                  >
                    x</span
                  >
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <label class="text-grey">Email</label>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text class="padding-none">
                  <b-button
                    class="bg-white color-orange font-bolder"
                    @click="addEmail"
                    :disabled="isEnabledEmail"
                  >
                    +</b-button
                  >
                </b-input-group-text>
              </template>
              <b-form-input
                type="email"
                @keyup="validateEmail"
                v-model="valueAdded.email"
                class="border-right-none"
                size="md"
                placeholder="Escriba aquí"
              >
              </b-form-input>
            </b-input-group>
            <p>{{ msg }}</p>
          </b-col>
        </b-row>
        <b-row v-show="formProvider.emails.length" class="padding-two-top">
          <b-col cols="12">
            <div class="border-grey">
              <ul class="padding-none">
                <li
                  class="bg-orange"
                  v-for="(email, index) in formProvider.emails"
                  :key="index"
                >
                  {{ email.contact }}
                  <span
                    class="bg-white color-black"
                    @click="deleteEmail(index)"
                  >
                    x</span
                  >
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <label class="text-grey">Teléfono</label>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text class="padding-none">
                  <b-button
                    class="bg-white color-orange font-bolder"
                    @click="addPhone"
                  >
                    +</b-button
                  >
                </b-input-group-text>
              </template>
              <b-form-input
                @keyup="acceptPhoneNumber"
                maxlength="7"
                type="text"
                v-model="valueAdded.phone"
                class="border-right-none"
                size="md"
                placeholder="Escriba aquí"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row v-show="formProvider.phones.length" class="padding-two-top">
          <b-col cols="12">
            <div class="border-grey">
              <ul class="padding-none">
                <li
                  class="bg-orange"
                  v-for="(phone, index) in formProvider.phones"
                  :key="index"
                >
                  {{ phone.contact }}
                  <span
                    class="bg-white color-black"
                    @click="deletePhone(index)"
                  >
                    x</span
                  >
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <label class="text-grey">Celular</label>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text class="padding-none">
                  <b-button
                    class="bg-white color-orange font-bolder"
                    @click="addCellphone"
                  >
                    +</b-button
                  >
                </b-input-group-text>
              </template>
              <b-form-input
                type="text"
                @keyup="acceptNumber"
                maxlength="9"
                v-model="valueAdded.cellphone"
                class="border-right-none"
                size="md"
                placeholder="Escriba aquí"
              >
              </b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row v-show="formProvider.cellphones.length" class="padding-two-top">
          <b-col cols="12">
            <div class="border-grey">
              <ul class="padding-none">
                <li
                  class="bg-orange"
                  v-for="(cellphone, index) in formProvider.cellphones"
                  :key="index"
                >
                  {{ cellphone.contact }}
                  <span
                    class="bg-white color-black"
                    @click="deleteCellphone(index)"
                  >
                    x</span
                  >
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bg-white padding-five-all">
      <h5 class="color-orange">Capacidades</h5>
      <b-container fluid>
        <b-row>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">SKU Servicio</label>
            <b-form-input
              @keyup="searchSkuService"
              placeholder="Escriba aquí"
              type="text"
              v-model="valueCapacities.service"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Descripción servicio</label>
            <b-form-input
              readonly
              placeholder="Escriba aquí"
              type="text"
              v-model="valueCapacities.description"
            ></b-form-input>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Turno</label>

            <b-form-group>
              <b-form-select
                v-model="valueCapacities.turn"
                size="md"
                :options="optionShip"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Día</label>
            <b-form-group>
              <b-form-select
                @change="clearOptionSelected"
                v-model="valueCapacities.selectedFilterDay"
                size="md"
                :options="optionFilterDays"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <template v-if="valueCapacities.selectedFilterDay == 'A'">
            <b-col cols="12" md="4" lg="4">
              <label class="text-grey">Día inicio</label>
              <b-form-group>
                <b-form-select
                  v-model="valueCapacities.startDay"
                  size="md"
                  :options="optionDays"
                >
                  <b-form-select-option :value="null"
                    >Seleccione una opción
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-grey">Día fin</label>
              <b-form-group>
                <b-form-select
                  v-model="valueCapacities.endDay"
                  size="md"
                  :options="optionDays"
                >
                  <b-form-select-option :value="null"
                    >Seleccione una opción
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </template>

          <b-col cols="12" md="4" lg="4" v-else>
            <label class="text-grey">Día</label>
            <b-form-group>
              <b-form-select
                v-model="valueCapacities.day"
                size="md"
                :options="optionDays"
              >
                <b-form-select-option :value="null"
                  >Seleccione una opción
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="12" md="4" lg="4">
            <label class="text-grey">Capacidad</label>
            <b-form-input
              placeholder="Escriba aquí"
              type="number"
              min="1"
              v-model="valueCapacities.capacity"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="padding-four-top">
          <b-col cols="auto">
            <b-button
              :disabled="isEnabled"
              @click="addCapacity"
              class="btn-orange"
            >
              <font-awesome-icon icon="plus"></font-awesome-icon> Agregar
            </b-button>
          </b-col>
        </b-row>
        <b-row class="padding-four-top" v-if="formProvider.capacities.length">
          <b-col cols="12">
            <b-table
              :items="formProvider.capacities"
              :fields="fieldsCapacities"
            >
              <template v-slot:cell(actions)="row">
                <b-button
                  size="sm"
                  @click="deleteRow(row.index)"
                  class="btn-purple"
                  >Eliminar
                </b-button>
              </template>
              <template v-slot:cell(capacity)="row">
                <b-form-input type="number" v-model="row.item.capacity" />
              </template>
              <template #cell(day)="row">
                <span v-if="row.item.day">
                  {{ row.item.day }}
                </span>
                <span v-else>
                  {{ row.item.startDay }} a {{ row.item.endDay }}
                </span>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" class="text-center">
            <b-button class="btn-orange" @click="registerProvider">
              <font-awesome-icon icon="save" />
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "CreateProvider",
  data() {
    return {
      msg: "",
      valueAdded: { email: "", phone: "", cellphone: "", sucursal: null },
      capacities: [],
      fieldsCapacities: [
        { key: "service", label: "Sku Servicio" },
        { key: "serviceName", label: "Descripción" },
        { key: "turn", label: "Turno" },
        { key: "capacity", label: "Capacidad" },
        { key: "day", label: "Día" },
        { key: "actions", label: "" },
      ],
      formProvider: {
        id: 0,
        cutHour: "",
        cutHourEx:"",
        direction: "",
        name: "",
        password: "",
        prefix: "",
        ruc: "",
        socialReason: "",
        state: "ACTIVE",
        user: "",
        type: null,
        beetrack: false,
        automaticSO: false,
        express:false,
        branchAssignations: [],
        phones: [],
        emails: [],
        cellphones: [],
        capacities: [],
        enterpriseAssignations:[]
      },
      optionStates: [{ value: "ACTIVE", text: "ACTIVO" }],
      status: "",
      optionStores: [],
      optionFilterDays: [
        { value: "A", text: "Rango de días" },
        { value: "B", text: "Día único" },
      ],
      optionDays: [
        { value: "MONDAY", text: "Lunes" },
        { value: "TUESDAY", text: "Martes" },
        { value: "WEDNESDAY", text: "Miércoles" },
        { value: "THURSDAY", text: "Jueves" },
        { value: "FRIDAY", text: "Viernes" },
        { value: "SATURDAY", text: "Sábado" },
        { value: "SUNDAY", text: "Domingo" },
      ],
      optionShip: [
        { value: "MORNING", text: "Mañana" },
        { value: "AFTERNOON", text: "Tarde" },
        { value: "ALL_DAY", text: "Durante el día" },
      ],
      optionTypeProvider: [
        { value: "OWNED", text: "PROPIO" },
        { value: "THIRD_PARTY", text: "TERCERO" },
      ],
      valueCapacities: {
        capacity: "",
        turn: null,
        startDay: null,
        endDay: null,
        service: "",
        selectedFilterDay: "A",
        day: "",
        description: "",
      },
      listSkuServices: [],
      selectedCompany: null, // Array reference
      companies: [
        { value: { companyCode:100, companyName: "HPSA" }, text: "PROMART", disabled: false},
        { value: { companyCode:300, companyName: "SPSA" }, text: "PLAZA VEA", disabled: false }
      ]
    };
  },
  created() {
    //this.getSkuServices()
    this.getStores();
  },
  computed: {
    isEnabledEmail() {
      if (this.msg || !this.valueAdded.email) return true;
      else return false;
    },
    isEnabled() {
      if (
        this.valueCapacities.service.length > 0 &&
        this.valueCapacities.capacity.length > 0
      )
        return false;
      return true;
    },
    filteredSucursal() {
      return this.formProvider.branchAssignations.filter(
        (v, i, a) => a.findIndex((t) => t.storeCode === v.storeCode) === i
      );
    },
    ...mapState("module", ["username","token"]),
  },
  methods: {
    validateEmail() {
      const mailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!mailRegex.test(this.valueAdded.email)) {
        this.msg = "Ingrese un email válido";
      } else {
        this.msg = "";
      }
    },
    acceptNumber() {
      this.valueAdded.cellphone = this.valueAdded.cellphone.replace(
        /[^0-9]/g,
        ""
      );
    },
    acceptPhoneNumber() {
      this.valueAdded.phone = this.valueAdded.phone.replace(/[^0-9]/g, "");
    },
    clearOptionSelected() {
      this.valueCapacities.startDay = null;
      this.valueCapacities.endDay = null;
      this.valueCapacities.day = null;
    },
    async searchSkuService() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services/" +
            this.valueCapacities.service,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);
        this.valueCapacities.description = response.data.description;
      } catch (error) {
        console.error(error);
      }
    },
    async getSkuServices() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services?limit=100&page=1&pageable=true",
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );

        this.listSkuServices = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async registerProvider() {
      try {
        this.$store.commit("SET_LOADING", true);
        let userFormat = this.formProvider.user.replace(/-/g, "");
        let prefix = userFormat.substring(0, 3);
        this.formProvider.prefix = prefix;
        let response = await axios.post(
          process.env.VUE_APP_PROVIDER_BASE_BUSINESS + "/providers",
          this.formProvider,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);

        let values = { variant: "success", msg: "Se ha creado exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.$router.go(-1);
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    addCapacity() {
      this.formProvider.capacities.push({
        capacity: this.valueCapacities.capacity,
        day: this.valueCapacities.day,
        startDay: this.valueCapacities.startDay,
        endDay: this.valueCapacities.endDay,
        service: this.valueCapacities.service,
        serviceName: this.valueCapacities.description,
        turn: this.valueCapacities.turn,
        children: [],
        deleted: false,
      });
      this.clearCapacities();
    },
    clearCapacities() {
      this.valueCapacities.capacity = "";
      this.valueCapacities.day = null;
      this.valueCapacities.startDay = null;
      this.valueCapacities.endDay = null;
      this.valueCapacities.service = "";
      this.valueCapacities.description = "";
      this.valueCapacities.turn == null;
    },
    deleteRow(index) {
      this.formProvider.capacities.splice(index, 1);
    },
    deleteSucursal(index, storeCode) {
      this.formProvider.branchAssignations.splice(index, 1);
      this.enableOptionSucursal(storeCode);
    },
    deleteCompany(index, companyCode) {
      this.formProvider.enterpriseAssignations.splice(index, 1);
      this.enableOptionCompany(companyCode);
    },
    enableOptionCompany(companyCode) {
      var i = this.companies.findIndex((s) => s.value.companyCode === companyCode);
      this.companies[i].disabled = false;
    },
    addSucursal() {
      this.formProvider.branchAssignations.push({
        storeCode: this.valueAdded.sucursal.code,
        storeName: this.valueAdded.sucursal.store,
      });
      this.disableOptionSucursal();
      this.valueAdded.sucursal = null;
    },
    addCompany() {
      this.formProvider.enterpriseAssignations.push({
        companyCode: this.selectedCompany.companyCode,
        companyName: this.selectedCompany.companyName,
        providerId:this.formProvider.id
      });
      this.disableOptionCompany();
     
    },
    disableOptionCompany(){
      let code = this.selectedCompany.companyCode;
      var i = this.companies.findIndex((s) => s.value.companyCode == code);
      this.companies[i].disabled = true;
    },
    disableOptionSucursal() {
      let code = this.valueAdded.sucursal.code;
      var i = this.optionStores.findIndex((s) => s.value.code == code);
      this.optionStores[i].disabled = true;
    },
    enableOptionSucursal(storeCode) {
      var i = this.optionStores.findIndex((s) => s.value.code === storeCode);
      this.optionStores[i].disabled = false;
    },
    addEmail() {
      this.formProvider.emails.push({
        contact: this.valueAdded.email,
        type: "EMAIL",
      });
      this.valueAdded.email = null;
    },
    addPhone() {
      this.formProvider.phones.push({
        contact: this.valueAdded.phone,
        type: "PHONE",
      });
      this.valueAdded.phone = null;
    },
    addCellphone() {
      this.formProvider.cellphones.push({
        contact: this.valueAdded.cellphone,
        type: "CELLPHONE",
      });
      this.valueAdded.cellphone = null;
    },
    deletePhone(index) {
      this.formProvider.phones.splice(index, 1); // why is this removing only the last row?
    },
    deleteEmail(index) {
      this.formProvider.emails.splice(index, 1); // why is this removing only the last row?
    },
    deleteCellphone(index) {
      this.formProvider.cellphones.splice(index, 1);
    },

    async getStores() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ENDPOINT_STORE + "/stores?limit=1000&page=1",
          {
          headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            }
          }
        );
        const data = response.data.map((row) => {
          return {
            value: { code: row.code, store: row.name },
            text: row.code + " - " + row.name+ " - " +row.company,
            disabled: false,
          };
        });
        this.optionStores = data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
::v-deep option:disabled {
  background-color: #e9ecef !important;
  opacity: 1 !important;
}

.btn-purple {
  background: transparent;
  color: #ff005d;
}

.btn-secondary {
  border: none !important;
}

::v-deep .display-inline-flex .bv-no-focus-ring {
  display: inline-flex;
}
.bg-orange {
  background: orange;
  padding: 7px;
  margin: 3px;
  border-radius: 15px;
  color: white;
  font-size: 12px;
  display: inline-block;
}
.color-black {
  color: orange;
  border-radius: 50%;
  font-size: 9px;
  padding: 0.65px 4px 0.65px 4px;
}

.padding-ten-tb {
  padding-top: 10px;
  padding-bottom: 10px;
}
.border-grey {
  border: 1px solid #ced4da;
  padding: 15px;
  border-radius: 10px;
}

.padding-two-top {
  margin-top: 1.5%;
}
.color-orange {
  color: #ff7a00;
}
.font-bolder {
  font-weight: bold;
  font-size: 23px;
  padding: 0;
  background: transparent;
  border-color: transparent;
}

.color-gray {
  color: #676767;
  font-weight: bold;
}
.padding-four-top {
  padding-top: 2.5%;
}
.padding-none {
  padding: 0;
  margin: 0;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
</style>
